export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL as string;
export const CREATE_USER = `${BASE_URL}/v1/users/register`;
export const LOGIN = `${BASE_URL}/v1/auth/login`;
export const GOOGLE_LOGIN = `${BASE_URL}/v1/auth/google/login`;
export const LOGOUT = `${BASE_URL}/v1/auth/logout`;
export const CREATE_ORDER = `${BASE_URL}/v1/payments/route/create-order`;
export const PROFILE = `${BASE_URL}/v1/profile`;
export const CATEGORIES = `${BASE_URL}/v1/profile/category`;
export const USERS = `${BASE_URL}/v1/users`;
export const SUPPORTERS = `${BASE_URL}/v1/supporters`;
export const WALLET = `${BASE_URL}/v1/wallet`;
export const FORGET_PASSWORD = `${USERS}/send-reset-password-mail`;
export const RESET_PASSWORD = `${USERS}/mail/reset-password`;
export const CHANGE_PASSWORD = `${USERS}/change-password`;
export const ACCOUNT_DETAILS = `${USERS}/account-details`;
export const DASHBOARD_ORDERS = `${BASE_URL}/v1/payments/dashboard-orders`;
export const DASHBOARD_PROFILE = `${BASE_URL}/v1/profile/dashboard`;
export const PAYOUTS = `${BASE_URL}/v1/payments/fetch-payouts`;
export const STREAM_ALERTS = `${BASE_URL}/v1/stream-alerts`;
export const SETTLEMENTS = `${BASE_URL}/v1/settlement`;

export const CREATOR_KYC = `${BASE_URL}/v1/creator-kyc`;
export const BUSINESS_TYPE = `${CREATOR_KYC}/business-type`;
export const BUSINESS_CATEGORY = `${CREATOR_KYC}/business-category`;
export const BUSINESS_SUBCATEGORY = `${CREATOR_KYC}/business-subcategory`;
